<template>
	<div id='fixedAssets'>
		<div class="public-content">
			<div class="form-item-public clearfix">
				<div class="fr">
					<el-form inline>
						<el-form-item>
							<el-button size='mini' v-for='item in buttons' :key="item.id" @click="handleButtonOperation(item.function)" class='minButton'>
								{{item.name}}
							</el-button>
						</el-form-item>
					</el-form>
				</div>
			</div>
			<public-table :table='tableData' @onHandleoperate="handleOperation" @onHandlePaginationChange="handlePaginationChange"
				ref="singleTable">
				<template slot='zhejiuStyle' slot-scope="props">
					<el-select
						size="mini"
						placeholder="请选择"
						@change="changeTask(props.scope.row,props.scope.row.zhejiuStyle)"
						v-model="props.scope.row.zhejiuStyle">
							    <el-option
							    	v-for="item in zhejiuStyleOptions"
							    	:key="item.value"
							    	:label="item.label"
							    	:value="item.value">
							    </el-option>
						  	</el-select>
				</template>
      </public-table>
		</div>
		<!-- 添加/修改资产 -->
		<asset-dialog
			:showVisible.sync="isShowDialog"
			:tableData = 'tableDataAdd'
			:assetForm="assetForm"
			@onRefresh="refresh">
		</asset-dialog>

    <!-- 导入 -->
    <el-dialog
      width="600px"
      :visible.sync="importVisible"
      :show-close="false"
      :close-on-click-modal="false"
      custom-class="import_dialog"
      title="导入固定资产"
      center
      @close="files = []"
    >
      <el-form ref="form" label-width="100px" label-position="left">
        <el-form-item label="上传文件：">
          <el-upload
            class="upload-demo"
            action=""
            :auto-upload="false"
            drag
            accept=".xlsx"
            :on-change="handleChange"
            :file-list="files">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          </el-upload>
          <el-button type="text" @click="downloadTemplate" class="template_download" icon="el-icon-download">下载模板</el-button>
        </el-form-item>
      </el-form>
      <div class="footer">
        <el-button size="small" @click="importVisible = false">取 消</el-button>
        <el-button size="small" class="submit" @click="submit">确 定</el-button>
      </div>
    </el-dialog>
	</div>
</template>
<script>
	import AssetDialog from '@/components/dialog/assets'
	import {currencys} from '@/assets/utils/currencyFormat'
	import publicTable from '@/components/publicTable'
	import {changeDepreciationStatus} from '@/api'
	export default {
		components: {
			publicTable,
			AssetDialog
		},
		data() {
			return {
				zhejiuStyleOptions:[{					// 折旧方式
					label: '年限平均法',
					value: '1'
				},{
					label: '不提折旧',
					value: '5'
				}],
				tableDataAdd:"",
				buttons:[],
				assetForm: {
					data: {
						cid: '',
						id: '',
						assetsCode: '',
						assetsName: '',
						assetsGenresId: '',
						entryTime: '',
						entryTimeStamp: '',
						departName: '',
						startUse: '',
						clearPeriod: '',
						zhejiuStyle: '1',
						expectYear: 0,
						fixationSubjectId: '',
						depreciationSubjectId: '',
						apportionSubjectId: '',
						paySubjectId: '',
						resourceAssets: '0.00',
						residualRatio: '0.00',
						depreciationReserves: '0.00',
						beginningNetvalue: '0.00',
						monthdepreciation: '0.00',
						depreciationPeriod: 0,
						beginningDepreciation: '0.00',
						salvage: '0.00',
						remarks: '',
						yearPeriods: "",
						adds: {
							name: '',
							id: ''
						},
					},
					title: '新增资产',
					status: 'add'
				},
				isShowDialog: false,
				tableData: {
					border: true,				// 是否带有纵向边框
					stripe: true,				// 是否带有斑马纹
					loading: false,				// 是否显示加载动画
					hasSelect: false,			// 是否显示多选
					hasOperation: true,			// 是否有操作功能
					hasContextmenu: false,		// 是否有右键功能
					hasShowSummary: false,		// 是否显示合计行
					hasShowPagination: true,	// 是否显示分页
					config: [{
						label: '编码',
						value: 'assetsCode',
						width: 80,
						fixed: true,
						show: 'normal'
					},{
						label: '名称',
						value: 'assetsName',
						fixed: true,
						show: 'normal'
					},{
						label: '类别',
						value: 'genresName',
						show: 'normal',
					},{
						label: '部门',
						value: 'departName',
						show: 'normal'
					},{
						label: '月折旧额',
						value: 'monthdepreciation',
						formatter: this.formatters,
						show: 'normal'
					},{
						label: '资产原值',
						formatter: this.formatters,
						value: 'resourceAssets',
						show: 'normal'
					},{
						label: '残值率',
						value: 'residualRatio',
						show: 'normal'
					},{
						label: '残值',
						value: 'salvage',
						formatter: this.formatters,
						show: 'normal'
					},{
						label: '期初累计折旧',
						value: 'beginningDepreciation',
						show: 'normal'
					},{
						label: '期末累计折旧',
						value: 'endDepreciation',
						show: 'normal'
					},{
						label: '减值准备',
						value: 'depreciationReserves',
						show: 'normal',
						formatter: this.formatters,
					},{
						label: '期初净值',
						value: 'beginningNetvalue',
						formatter: this.formatters,
						show: 'normal'
					},{
						label: '期末净值',
						value: 'endNetvalue',
						formatter: this.formatters,
						show: 'normal'
					},{
						label: '预计使用期限',
						value: 'expectYear',
						width: 50,
						show: 'normal'
					},{
						label: '已折旧期间数',
						value: 'depreciationPeriod',
						width: 50,
						show: 'normal'
					},{
						label: '开始使用日期',
						value: 'startUse',
						width: 105,
						formatter: this.formatter,
						show: 'normal',
					},{
						label: '状态',
						value: 'state',
						show: 'normal',
						formatter: this.formatter,
					},{
						label: '折旧方式',
						value: 'zhejiuStyle',
						show: 'template',
						width:105,
						// formatter: this.formatter,
					},{
						label: '累计折旧科目',
						value: 'depreciationSubjectName',
						width: 105,
						show: 'normal'
					},{
						label: '折旧费用分摊科目',
						value: 'apportionSubjectName',
						width: 135,
						show: 'normal'
					},{
						label: '备注',
						value: 'remarks',
						show: 'normal'
					}],
					operation: {
						label: '操作',
						value: 'operation',
						fixed: 'right',
						width: 100,
						data: [{
							label: '修改',
							value: 'editor',
						},{
							label: '删除',
							value: 'delete'
						}]
					},
					data: [],
					page: {
						count: 10,
						pageNo: 1,
						pageSize: 20
					},
					center: {
						textAlign: 'center',
						padding: '6px 0'
					}
				},
        importVisible:false, // 固定资产导入弹窗
        files:[], // 文件导入内容
			}
		},
		created() {
			this.getTableList();
			this.getAccountPeriods();
			let params=['ac:fixedAsset:export','ac:fixedAssets:save','ac:fixedAssets:import'];
			this.setButtons(params,'buttons');
		},
		computed: {
			// 获取会计期间
			// getAccountPeriod() {
			// 	return this.$store.state.accountInfo.yearPeriods.endYearPeriods;
			// },
		},
		methods: {
			async changeTask(row,value){
				const {data} = await changeDepreciationStatus({id:row.id,zhejiuStyle:value})
				if(data.code == 1){
					this.$message.success(data.msg)
					this.getTableList();
				}
			},
			// 表格格式化
			formatters(row, column, cellValue, index) {
				if(!row[column.property]) {
					return "";
				}else {
					return currencys(row[column.property]);
				}
			},
			// 格式化
			formatter (row, column, cellValue, index) {
				switch (column.property) {
					case 'startUse':
						return this.$util.formatDate.format(row[column.property], 'yyyy-MM-dd');
						break;
					case 'state':
						return row[column.property] == '0' && '正常使用' || row[column.property] == '1' && '非正常使用';
						break;
					case 'zhejiuStyle':
						return row[column.property] == '1' && '年限平均法' || row[column.property] == '5' && '不提折旧';
						break;
				}
			},

		// 给按钮设置值
		setButtons(arr,key){
			let params={
				permissions:arr.join(',')
			}
			try {
				this.$http.post('sys/menu/findPermissionMenu' , params).then(res=>{
					if(res && res.data.code == 1) {
						if(res.data.data.length){
							this[key] = res.data.data;
						}
					}
				})
			}catch(e){
			}
		},

		handleButtonOperation(name){
			switch(name){
				case 'fixedAssetsSave':
				this.openDialog();
				break;
				case 'fixedAssetExport':
					const params = {
						cid: sessionStorage.cid,
						token: sessionStorage.token
					}
					const router =this.$router.resolve({
						path: 'auxiliary/fixedAssetAsseDetail',
						query: params
					})
					location.href = this.$rootUrl + router.href
				break;
        case "fixedAssetsImport":
          this.importVisible = true
        break;
			}
		},

			// 获取会计期间
			getAccountPeriods() {
				if(!this.getAccountPeriod) {
					this.$store.dispatch('getAllYearPeriodsData')
				}
			},
			// 获取表格
			getTableList() {
				try{
					this.tableData.loading = true;
					this.$http.post('fixed/list' , this.tableData.page).then(res=>{
						if(res && res.data.code) {
							this.tableData.loading = false;
							this.tableData.data = res.data.data.list;
							this.tableData.data.forEach(item=>{
								for (const i in item) {
									if (typeof item[i] === 'number') {
										item[i] = item[i] == 0 ? '' : item[i];
									}
								}
							})
							this.$set(this.tableData, 'page', {
								count: Number(res.data.data.totalCount),
								pageNo:  Number(res.data.data.currentPage),
								pageSize:  Number(res.data.data.maxResult),
							})
							if(this.assetForm.data.id && this.tableData.data.length) {
								this.tableData.data.forEach(i=>{
									if(this.assetForm.data.id === i.id) {
										this.tableDataAdd = i.adds.id;
									}
								})
							}
						}
					})
				}catch(e){

				}finally{
					this.tableData.loading = false;
				}

			},
			// 打开弹出
			openDialog (row) {

				const prevent =  this.$getSessionStorage('superPreventOperation');
				if(prevent) {
					this.$store.commit('SUPERPREVENTFUNCTION',true);
					return;
				}
				this.isShowDialog = true;
				this.assetForm = Object.assign(this.assetForm, this.$options.data().assetForm);
				this.assetForm.data.yearPeriods = this.getAccountPeriod;
			},
			// 表格操作
			handleOperation (data) {
				const prevent =  this.$getSessionStorage('superPreventOperation');
				if(prevent) {
					this.$store.commit('SUPERPREVENTFUNCTION',true);
					return;
				}
				const { methods, row } = data;
				switch (methods) {
					case 'editor':
						this.handleEditor(row);
						break;
					case 'delete':
						this.handleDelete(row);
						break;
				}
			},
			// 编辑
			handleEditor (row) {
				this.assetForm = Object.assign(this.assetForm, {
					data: row,
					title: '修改资产类别',
					status: 'editor'
				});
				this.tableDataAdd = row.adds.id;
				this.isShowDialog = true;
			},
			// 删除
			handleDelete (row) {
				this.$refs.singleTable.$refs.table.setCurrentRow(row);

				try {
					this.$confirm(`确定删除名称为“${row.assetsName}”的数据吗？`, '提示', {
							type: 'warning',
							closeOnClickModal: false
					}).then(()=>{
						try {
							this.tableData.loading = true;
							this.$http.post('fixed/deletefixe' , {id: row.id}).then(res=>{
								this.tableData.loading = false;
								if(res&&res.data.code==1) {
									this.$message({
										type: 'success',
										message: res.data.msg,
										showClose: true
									})
									this.getTableList()
								}
							})

						} catch (e) {
							this.tableData.loading = false;
						}finally{
							this.tableData.loading = false;
						}

					})
				} catch(e) {
					this.$refs.singleTable.$refs.table.setCurrentRow();
				}
			},
			// 重载Table列表
			refresh (val) {
				val && this.getTableList();
			},
			// 分页
			handlePaginationChange ({ pageNo, pageSize }) {
				pageNo && this.$set(this.tableData.page, 'pageNo', pageNo);
				pageSize && this.$set(this.tableData.page, 'pageSize', pageSize);
				this.getTableList();
			},
      // 文件导入
      handleChange(file,fileList){
        this.files = [fileList[0]]
        if(fileList.length>1){
          this.$message.error('不支持多文件上传')
          return false
        }
        let testmsg = file.name.substring(file.name.lastIndexOf('.')+1)
        const extension2 = testmsg === 'xlsx'
        if(!extension2) {
          this.$message({
            message: '上传文件只能是 xlsx 格式!',
            type: 'error'
          });
          this.files = []
          return false
        }
      },
      // 导入确定
      submit(){
        if(!this.files.length){
          this.$message.error('请上传文件')
          return
        }
        let formData = new FormData()
        formData.append('file',this.files[0].raw)
        formData.append('cid',sessionStorage.getItem('cid'));

        this.$http.post('fixed/importFixedAssets', formData, {upload:true}).then(res=>{
          if(res.data.code == '1'){
            this.importVisible = false
            this.getTableList()
          }
        }).catch(err=>{
          console.log(err);
        }).finally(()=>{

        })
      },
      // 模板下载
      downloadTemplate(){
        let cid=sessionStorage.getItem('cid');
		    let token=sessionStorage.getItem('token');
        const templateName = '固定资产导入.xlsx'
        window.open(`${this.$rootUrl}voucherChief/download?cid=${cid}&token=${token}&templateName=${templateName}`)
      },
		},
		mounted() {

		}
	}
</script>
<style lang='less' scoped>
  /deep/.import_dialog{
    .el-dialog__title{
      font-weight: 500;
      color: #333;
      font-size: 24px;
    }

    .template_download{
      color: #269D7B;
      background-color: #F6F8FA;
      padding: 10px;
    }

    .footer {
      display: flex;
      justify-content: center;

      .el-button{
        width: 100px;

        &:first-child:hover{
          color: #269d7b;
          background-color: #fff;
          border-color: #269d7b;
          color: #269d7b;
        }
      }

      .submit{
        margin-left: 20px;
        color: #fff;
        background-color: #269d7b;
      }

    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/assets/fixedAssets.vue